import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { ViewExtraLarge, Viewport } from '@shared-ui/viewport-context';

import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';

import { MainRegion } from './main-region';
import { sideRailTypes } from './master-page';

export interface BodyRegionProps {
  toolbarType: string;
  mainContent: React.ReactElement<unknown>;
  sideRailContent: React.ReactElement<unknown>;
  toolbarContent: React.ReactElement<unknown>;
  navigationContent: React.ReactElement<unknown>;
  sideRailType: string;
  pageHeader?: string;
}

const mainDefault = (
  <MainRegion>
    <h1>No content has been set for main region</h1>
  </MainRegion>
);
const sideRailMaxWidth = 184;

export class BodyRegion extends React.Component<BodyRegionProps> {
  public render() {
    const { mainContent, sideRailContent, toolbarContent, sideRailType, navigationContent, pageHeader } = this.props;

    const mainContentRegion = <ErrorBoundary label="hotel.masterPage.main">{mainContent || mainDefault}</ErrorBoundary>;
    const sideRailContentRegion = sideRailContent && <ErrorBoundary label="hotel.masterPage.sideRail">{sideRailContent}</ErrorBoundary>;
    const toolbarContentRegion = toolbarContent && (
      <div className={this.props.toolbarType}>
        <ErrorBoundary label="hotel.masterPage.toolbar">{toolbarContent}</ErrorBoundary>
      </div>
    );
    const navigationContentRegion = navigationContent && (
      <ErrorBoundary label="hotel.masterPage.navigation">{navigationContent}</ErrorBoundary>
    );
    const header = pageHeader && (
      <header>
        <h1 className="is-visually-hidden">{pageHeader}</h1>
      </header>
    );

    if (sideRailType === sideRailTypes.NEXT_TO_MAIN) {
      return (
        <div className="xl-x-margin-six l-x-margin-six m-x-margin-six">
          {header}
          {toolbarContentRegion}
          {navigationContentRegion}
          <div className="uitk-flex-grow-1 uitk-cell">{mainContentRegion}</div>
          <div className="uitk-flex-shrink-1 side-rail uitk-flex uitk-flex-column">{sideRailContentRegion}</div>
        </div>
      );
    } else if (sideRailType === sideRailTypes.NEXT_TO_MAIN_AND_TOOLBAR) {
      return (
        <div className="xl-x-margin-six l-x-margin-six m-x-margin-six">
          <UitkLayoutFlex className="main-region">
            <UitkLayoutFlexItem className="main-body m-t-margin-two l-t-margin-three xl-t-margin-three">
              <div>
                {header}
                {toolbarContentRegion}
                {navigationContentRegion}
                {mainContentRegion}
              </div>
            </UitkLayoutFlexItem>
            <Viewport>
              <ViewExtraLarge>
                <UitkLayoutFlexItem className="side-rail" maxWidth={sideRailMaxWidth}>
                  <div>{sideRailContentRegion}</div>
                </UitkLayoutFlexItem>
              </ViewExtraLarge>
            </Viewport>
          </UitkLayoutFlex>
        </div>
      );
    }

    return (
      <>
        {navigationContentRegion}
        {toolbarContentRegion}
        {mainContentRegion}
      </>
    );
  }
}
